export enum AmplitudeSourceType {
  MERCHANT_SITE = 'Deposit',
  PAYMENT_LINK = 'Payment Link',
  WALLET_TRANSFER = 'Wallet Transfer',
  CASHOUT = 'Cashout',
  ONETOUCH_SIGN_IN = 'OT Sign in',
  NONE = 'None',
}

export enum AmplitudeDepositFlow {
  REVERSE = 'Reverse',
  REVERSE_V2 = 'Reverse v2',
  CURRENT = 'Current',
  CURRENT_V2 = 'Current v2',
  PAY_BY = 'Pay by',
  RUC = 'Requires User Confirmation',
  RESELLER_ONLY = 'Resellers Only',
}

export enum AmplitudePurchaseType {
  MERCHANT_DEPOSIT = 'Merchant Deposit',
  PAYMENT_LINK = 'Payment Link',
}

export enum AmplitudePMOwner {
  APC = 'AstroPay',
  TELLER = 'Teller',
}

export enum AmplitudeDepositMethodType {
  WALLET = 'Wallet',
  APC = 'APC',
  TOP_UP_WALLET = 'Top-up Wallet',
  PURCHASE = 'Purchase',
}

export enum AmplitudeVoucherType {
  SELECTED = 'Selected',
  ENTERED = 'Entered',
}

export enum AmplitudeLinkType {
  QR = 'QR',
  LINK = 'Link',
}
